import React from 'react'
import './Mission.css'

const Mission = () => {
  return (
    <div class="main1">
        <div className='top'>
        <p className='topp'>Mission And Vision</p>
        </div>
      
        <div class="c1">
            <p><q>Customized Solution Provider for Industrial Chains</q></p>

        </div>
        <div class="listm">
            <p><i>MISSION</i></p>
            <ol className='missli' start={1}>
                <li>Providing products as complete solutions.</li>
                <li>Establishment as leading name in global market by providing the Best performance. </li>
                <li>Retaining ourselves as the first choice for the established trade.</li>
                <li>Accountability for Human resource development, occupational, health & safety.</li>
                
            </ol>
            
            <p><i>VISION</i></p>
            <ol className='missli' start={1}>
                <li>Establishment of brand associated with quality and consistency in manufacturing all kind of chains in Asia & Europe by 2020 .</li>
                <li>Perfect Implementation Of Occupational Health and Safety Management System (OHSAS). </li>
                <li>Improving employee skills, involvement & Quality of Life (QOL).</li>
                
            </ol>
            <p><i>VALUES</i></p>
            <ol className='missli' start={1}>
                <li>Ethical Business Practices.</li>
                <li>Excellent Services. </li>
                <li>Continuous Customer Focus.</li>
                <li>Technology Enhancement.</li>
                
            </ol>


        </div>
    </div>
  )
}

export default Mission